import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { addDataToFirestore, checkUserCredentials } from "../firebaseService";
import Loader from './Loader';
import "../styles/LoginPage.css";
import mainImages from "../img/sce.png"; 

function LoginPage({ setUser }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    if (username.trim() && password.trim()) {
        setUser(username); 
      await  addDataToFirestore({ username: username, password: password });

    
      navigate("/projects");
    } else {
      alert("Будь ласка, введіть ім'я та пароль!");
    }
    setLoading(false);
  };
  const handleSignIn = async ()=> {
    setLoading(true);
   const  userCredentials = await checkUserCredentials(username, password)
console.log(userCredentials)
if(userCredentials) {
  setUser(username); 
  navigate("/projects");
} else {
  alert("Користувач не знайдений!");
}
setLoading(false);
  }

  const handleKeyDown = (e)=> {
    if (e.key === 'Enter') {
      handleLogin(); // Виклик кнопки "Увійти" при натисканні Enter
    }
  }

  return  loading? <Loader/> :(
    <div className="login-page">
            <h1>Платформа для шкільних соціальних підприємців</h1>
        <img src={mainImages} alt="" />
      <div className="login-container" onKeyDown={handleKeyDown}>
  <h2>Вхід на платформу</h2>
        <input
          type="text"
          placeholder="Введіть ваше ім'я"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Введіть ваш пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleSignIn}>Увійти</button>
        <button onClick={handleLogin}>Зареєструватися</button>
      </div>
    </div>
  );
}

export default LoginPage;